import { Row } from 'antd';
import styled from 'styled-components';

const ContentSelected = styled(Row)`
  background-color: white;

  .react-tel-input .country-list {
    background: white;
    padding-top: 0px;
    box-shadow: none;
    border: 1px solid #e7e9f1;
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;

  }

  .search {
    width: 100%;
    min-height: 30px;
    /* border-top-left-radius: 5px;
    border-top-right-radius: 5px; */
    padding-left: 0px;
    ::-webkit-scrollbar {
      width: 10px;
    }
  }
  .country-list {
    /* border-top-left-radius: 5px;
    border-top-right-radius: 5px; */
    ::-webkit-scrollbar {
      width: 0px;
    }
    ::-webkit-scrollbar-track {
      background: transparent;
    }
    ::-webkit-scrollbar-thumb {
      background: grey;
      border-radius: 15px;
      padding-right: 5px;
    }
  }

  .react-tel-input .country-list .search-box {
    padding: 10px;
    margin-left: 0px;
    width: 100%;
    border-color: transparent;
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;
    border-bottom:1px solid #e7e9f1;
  }
  .react-tel-input .country-list .country {
    margin-left: 10px;
    margin-right: 10px;
  }

  .form-control {
    min-height: 48px;
    /* border-color: 1px solid #e7e9f1; */

    color: black;
    ul {
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
    }
    input {
      overflow: hidden;
    }
  }
  .react-tel-input .country-list .search {
    padding-left: 0px;
    padding-top: 0px;
    width: 100%;
  }
  .eNMfdC .react-tel-input .country-list .search-box {
    width: 100%;
  }

  .search-box {
    /* border-top-left-radius: 5px;
    border-top-right-radius: 5px; */
  }

  .eQhhnG .react-tel-input .country-list .search {
    /* border-top-left-radius: 5px;
    border-top-right-radius: 5px; */
    border: none;
  }
  .cFCnnf .react-tel-input .country-list {
    /* border-top-left-radius: 5px;
    border-top-right-radius: 5px; */
  }

  input {
    overflow: hidden;
  }

  .country {
  }
`;

export { ContentSelected };
